import '@fontsource/be-vietnam-pro/400.css';
import '@fontsource/be-vietnam-pro/500.css';
import '@fontsource/be-vietnam-pro/600.css';
import '@fontsource/be-vietnam-pro/700.css';
import '@fontsource/be-vietnam-pro/800.css';
import '../styles/application.css';
import ReactOnRails from 'react-on-rails';
import App from '../app/App';
import AdminApp from '../admin/AdminApp';
import SignInButtons from '../app/components/SignInButtons';

// Inside the iOS/Android app, index.html sets MACRO_MATE_NATIVE and there's no Rails page to mount into:
// boot the native shell (token login) ourselves. On the website, Rails renders the App with its props.
if (window.MACRO_MATE_NATIVE) {
  Promise.all([import('react-dom/client'), import('react'), import('../native/NativeApp')])
    .then(([{ createRoot }, { createElement }, { default: NativeApp }]) => {
      createRoot(document.getElementById('root')).render(createElement(NativeApp));
    });
} else {
  ReactOnRails.register({ App, AdminApp, SignInButtons });
}
